package com.anjuros.website.templates.template8.styles


import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.util.Constants
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba



val Template8ButtonStyle = CssStyle {
    base { Modifier.margin(top = 40.px) }
    Breakpoint.MD {  Modifier.margin(top = 0.px) }
    Breakpoint.LG {Modifier.margin(top = 0.px) }
    Breakpoint.XL { Modifier.margin(top = 0.px)}
    base {
        Modifier
            .padding(leftRight = 0.px)
            .transition(Transition.of("padding", 200.ms))
    }
    hover {
        Modifier
            .padding(leftRight = 10.px)
            .width(Width.FitContent)
    }
}

val Template8NavigationItemStyle = CssStyle {


    base {
        Modifier
            .scale(1.0)
            .color(Template8Theme.Primary.rgb)
            .transition(Transition.of("color", 200.ms),
                Transition.of("scale", 200.ms))
    }
    hover {
        Modifier
            .scale(1.1)
            .color(Template8Theme.LightGrey.rgb)
    }
}

val Template8FooterTextStyle = CssStyle {
    base { Modifier.fontSize(20.px) }
    Breakpoint.MD {  Modifier.fontSize(16.px) }
    Breakpoint.LG {Modifier.fontSize(20.px) }
    Breakpoint.XL { Modifier.fontSize(20.px)}
}

val Template8FooterCopyrightTextStyle = CssStyle {
    base { Modifier .fontSize(12.px) }
    Breakpoint.MD {  Modifier .fontSize(10.px) }
    Breakpoint.LG {Modifier .fontSize(12.px) }
    Breakpoint.XL { Modifier .fontSize(12.px)}
}
val Template8FooterMarginStyle = CssStyle {
    base { Modifier.margin(topBottom = 20.px) }
    Breakpoint.MD { Modifier.margin(topBottom = 0.px) }
    Breakpoint.LG { Modifier.margin(topBottom = 0.px) }
    Breakpoint.XL { Modifier.margin(topBottom = 0.px)}
}

val Template8MenuWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(70.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(70.percent)}
}

val Template8LearnMoreWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(95.percent)
        .margin(top=100.px)}
    Breakpoint.MD { Modifier.fillMaxWidth(80.percent).padding(leftRight = 20.px) }
    Breakpoint.LG { Modifier.fillMaxWidth(60.percent).padding(leftRight = 20.px) }
    Breakpoint.XL { Modifier.fillMaxWidth(60.percent).padding(leftRight = 20.px)}
}

val Template8WhatsOnTitleTextStyle = CssStyle {
    base { Modifier .fontSize(24.px) }
    Breakpoint.MD {  Modifier .fontSize(30.px) }
    Breakpoint.LG {Modifier.fontSize(40.px) }
    Breakpoint.XL { Modifier .fontSize(40.px)}
}

val Template8WhatsOnCardStyle = CssStyle {
    base { Modifier .fillMaxWidth(90.percent)
        .margin(topBottom = 20.px)}
    Breakpoint.MD {  Modifier .width(300.px)
        .margin(20.px) }
    Breakpoint.LG {Modifier.width(400.px)
        .margin(30.px) }
    Breakpoint.XL { Modifier .width(400.px)
        .margin(30.px)}



    cssRule(" > #cardColumn>#whatsonImage") {
        Modifier
            .scale(1.0f)
            .transition(
                Transition.of(property = "scale", duration = 500.ms)
            )
    }
    cssRule(":hover > #cardColumn>#whatsonImage") {
        Modifier
            .scale(1.2f)


    }
}

